import {
    doc,
    getDoc,
    setDoc,
    serverTimestamp,
    collection,
    query,
    where,
    orderBy,
    limit,
    getDocs,
} from "firebase/firestore";
import { db } from "./firebase";

/**
 * Saves a score if:
 * - email does not exist, OR
 * - new score is higher than existing score
 */
export async function submitScore({
    firstName,
    email,
    score,
    correctCount,
    totalQuestions,
    timeSeconds,
    consentAds
}) {
    const emailKey = email.toLowerCase().trim();
    const scoreRef = doc(db, "scores", emailKey);

    const existingSnap = await getDoc(scoreRef);

    if (existingSnap.exists()) {
        return {
            success: false,
            reason: "email_exists",
        };
    }

    await setDoc(scoreRef, {
        firstName,
        email: emailKey,
        score,
        correctCount,
        totalQuestions,
        timeSeconds,
        consentAds,
        createdAt: serverTimestamp(),
    });

    return { success: true };
}

// function getWeekRange(date = new Date()) {
//     const d = new Date(date);
//     const day = d.getDay(); // 0 (Sun) - 6 (Sat)

//     const diff = day === 0 ? -6 : 1 - day;

//     const monday = new Date(d);
//     monday.setDate(d.getDate() + diff);
//     monday.setHours(0, 0, 0, 0);

//     const nextMonday = new Date(monday);
//     nextMonday.setDate(monday.getDate() + 7);

//     return { monday, nextMonday };
// }

export async function getWeeklyLeaderboard() {
    // const { monday, nextMonday } = getWeekRange();

    const q = query(
        collection(db, "scores"),
        // where("createdAt", ">=", monday),
        // where("createdAt", "<", nextMonday),
        // orderBy("createdAt", "asc"),
        orderBy("score", "desc"),
        // orderBy("timeSeconds", "asc"),
        // limit(50)
    );

    const snap = await getDocs(q);

    return snap.docs.map(doc => ({
        id: doc.id,
        ...doc.data(),
    }));
}

export function calculateScore({
    correctCount,
    totalQuestions,
    timeSeconds,
}) {
    const accuracyRatio = correctCount / totalQuestions;

    // Base score: accuracy dominates
    const accuracyScore = accuracyRatio * 1000;

    // Time penalty (faster = higher)
    const timePenalty = Math.min(timeSeconds, 600) * 2; // cap at 10 minutes

    return Math.max(0, Math.round(accuracyScore * 10 - timePenalty));
}
